// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"EnergyAssetsPortalConfig_wrapperPadding__2FhZ-"};